import { render, staticRenderFns } from "./OrganismGlobalSetting.vue?vue&type=template&id=33152be7&scoped=true&"
import script from "./OrganismGlobalSetting.vue?vue&type=script&lang=js&"
export * from "./OrganismGlobalSetting.vue?vue&type=script&lang=js&"
import style0 from "./OrganismGlobalSetting.vue?vue&type=style&index=0&id=33152be7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33152be7",
  null
  
)

export default component.exports